/**
 * @ngdoc service
 * @name app.archivesService
 * @description
 * # Categories Service
 * Service to talk with backend api to get archives information.
 * @requires app.apiService
 * @requires constants:config
 **/

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * regionService
 \*---------------------------------------------------------*/
/* @ngInject */
function archiveService(apiService, config) {
  // APIs
  /**
   * @ngdoc
   * @name app.archivesService#getArchives
   * @methodOf app.archivesService
   * @param {string} regionCode selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of two characters..
   * @example
   * ``` js
   * archivesService.getArchives('LI');
   * ```
   * @description
   * calls {@link app.apiService#wrap apiService.wrap} method with current base url,
   * '/news/categories/' and regionId'.
   * @returns {httpPromise} Promise that will resolve into an array or archives for
   * current region. each archive will have a tumbnail, a header, and a url to its video.
   **/
  this.getArchives = (regionCode) => {
    if (!angular.isString(regionCode) || regionCode.length !== 2) {
      throw new Error('A two-character region code is required');
    }
    return apiService.wrap(`${config.relBaseUrlAPi}/news/archives/${regionCode}`,
      {}, 'archives')
      .then((res) => {
        if (!res.data) {
          return [];
        }
        const data = res.data.rss.channel.item;
        return data.map((s) => {
          return {
            image: s['media:thumbnail'].url,
            header: s.title,
            videoUrl: s['media:content'].url
          };
        });
      });
  };
}

archiveService.$inject = [
  'apiService',
  'config'
];

const api = angular
  .module('archiveService', ['config', 'apiService'])
  .service('archiveService', archiveService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/archives.js
 **/